import { V } from "../../app/pages.js";
import { emp, me, used } from "../../services/access.js";
import { S, ui } from "../../app/store.js";
import { esc, peso } from "../../domain/format.js";
import { fmtD, roll } from "../../domain/dates.js";
import { LEAVE_CAP, LEAVE_TYPES } from "../../domain/reference.js";
import { ssn } from "../../components/ui.js";
import { plantLeaveRequestForm } from "../hrm/foundation.js";

V.me = () => {
  const e = emp(me().emp),
    r = [...S.runs].reverse().find((r) => r.status === "RELEASED"),
    l = r && r.lines.find((x) => x.emp === e.id),
    mine = S.leaves.filter((x) => x.emp === e.id && x.source !== "HRM_PLANT");
  return `<div class="grid">
   <section class="panel"><h2>${esc(e.name)}</h2><div class="small muted">${esc(e.position)} · ${esc(e.dept)} · since ${fmtD(e.hired)}</div>
    <div class="tbl"><table style="min-width:0"><tbody><tr><td>TIN</td><td class="num">${esc(e.tin)}</td></tr><tr><td>SSS</td><td class="num">${esc(e.sss)}</td></tr><tr><td>Monthly basic</td><td class="n">${peso(e.basic * 100)}</td></tr></tbody></table></div>
    <p class="small muted">Form 2316 for 2026 will be issued by ${fmtD(roll("2027-01-31"))}.</p></section>
   ${
     l
       ? `<section class="panel"><h2>Payslip · ${fmtD(r.from)} – ${fmtD(r.to)}</h2><div class="tbl"><table style="min-width:0"><tbody>
    <tr><td>Basic pay</td><td class="n">${peso(l.gross)}</td></tr><tr><td>SSS</td><td class="n">(${peso(l.sssEE)})</td></tr><tr><td>PhilHealth</td><td class="n">(${peso(l.phEE)})</td></tr><tr><td>Pag-IBIG</td><td class="n">(${peso(l.hdEE)})</td></tr><tr><td>Withholding tax</td><td class="n">(${peso(l.tax)})</td></tr>
    <tfoot><tr><td>Net pay</td><td class="n">${peso(l.net)}</td></tr></tfoot></tbody></table></div><p class="small muted">Paid ${fmtD(r.pay)}. Your employer also paid ${peso(l.er)} in contributions for you.</p></section>`
       : ""
   }
  </div>
  <section class="panel"><h2>Existing leave</h2>
   <div class="row">${["SIL", "VL", "SL"].map((t) => `<div class="kpi" style="flex:1 1 150px"><span class="lbl">${t}</span><span class="v">${LEAVE_CAP[t] - used(e.id, t)} / ${LEAVE_CAP[t]}</span><span class="small muted">days left</span></div>`).join("")}</div>
   <form id="lvform" class="form"><label>Type<select id="lv-type">${Object.entries(
     LEAVE_TYPES,
   )
     .map(([k, v]) => `<option value="${k}">${esc(v)}</option>`)
     .join("")}</select></label>
    <label>From<input type="date" id="lv-from" required></label><label>To<input type="date" id="lv-to" required></label><label>Reason<input id="lv-reason" required></label>
    ${ui.lvErr ? `<p class="err wide">${esc(ui.lvErr)}</p>` : ""}<label>&nbsp;<button class="pri" type="submit">File leave request</button></label></form>
   <div class="tbl"><table><thead><tr><th>Type</th><th>Dates</th><th class="n">Days</th><th>Status</th></tr></thead><tbody>${
     mine.length
       ? mine
           .slice()
           .reverse()
           .map(
             (x) =>
               `<tr><td>${esc(LEAVE_TYPES[x.type] || x.type)}</td><td>${fmtD(x.from)} – ${fmtD(x.to)}</td><td class="n">${x.days ?? "Pending review"}</td><td>${ssn(x.status)}</td></tr>`,
           )
           .join("")
       : `<tr><td colspan="4" class="muted">No requests yet.</td></tr>`
   }</tbody></table></div></section>${plantLeaveRequestForm()}`;
};
